import AuthThemeDark from './dark_theme/auth';
import DashboardThemeDark from './dark_theme/dashboard';
import ProfileThemeDark from './dark_theme/profile';
import DefaultThemeDark from './dark_theme/defaultTheme';
import AccountThemeDark from './dark_theme/account';
import MoreThemeDark from './dark_theme/more';
import FantasyThemeDark from './dark_theme/fantasy';
import EmptyDataThemeDark from './dark_theme/emptyData';
import ErrorThemeDark from './dark_theme/errorMessage';
import ComponentThemeDark from './dark_theme/component';
import VerifyAccountThemeDark from './dark_theme/verifyAccount';

import AuthThemeLight from './light_theme/auth';
import DashboardThemeLight from './light_theme/dashboard';
import ProfileThemeLight from './light_theme/profile';
import DefaultThemeLight from './light_theme/defaultTheme';
import AccountThemeLight from './light_theme/account';
import MoreThemeLight from './light_theme/more';
import FantasyThemeLight from './light_theme/fantasy';
import EmptyDataThemeLight from './light_theme/emptyData';
import ErrorThemeLight from './light_theme/errorMessage';
import ComponentThemeLight from './light_theme/component';
import VerifyAccountThemeLight from './light_theme/verifyAccount';

const darkTheme = {
  AuthTheme: AuthThemeDark,
  DashboardTheme: DashboardThemeDark,
  ProfileTheme: ProfileThemeDark,
  DefaultTheme: DefaultThemeDark,
  AccountTheme: AccountThemeDark,
  MoreTheme: MoreThemeDark,
  FantasyTheme: FantasyThemeDark,
  EmptyDataTheme: EmptyDataThemeDark,
  ErrorTheme: ErrorThemeDark,
  ComponentTheme: ComponentThemeDark,
  VerifyAccountTheme: VerifyAccountThemeDark
};

const lightTheme = {
  AuthTheme: AuthThemeLight,
  DashboardTheme: DashboardThemeLight,
  ProfileTheme: ProfileThemeLight,
  DefaultTheme: DefaultThemeLight,
  AccountTheme: AccountThemeLight,
  MoreTheme: MoreThemeLight,
  FantasyTheme: FantasyThemeLight,
  EmptyDataTheme: EmptyDataThemeLight,
  ErrorTheme: ErrorThemeLight,
  ComponentTheme: ComponentThemeLight,
  VerifyAccountTheme: VerifyAccountThemeLight
};

const Themes = {
  dark: darkTheme,
  light: lightTheme
} as any;

export default Themes;
